import React, { Fragment, useContext, useState, useEffect, useRef } from 'react'
import {
  getBadgeClass,
  ChecklistPhase,
  ChecklistItemStatus,
  mdyyyy,
  getChecklistItemDate,
  getDisplayLabel,
  ChecklistItemType,
  isSolarMonitoringChecklistItem,
  LoanApplicationPhaseShared
} from '@oneethos/shared'
import { AppContext } from '../appContext'
import { selectChecklistItemsByPhase } from '../selectors/checklistItems'
import { CheckboxIcon } from './checkbox-icon'
import InstallerUploadForm from './documents/installer-upload-form'

export const LoanApplicationPhase = ({ project, onChange, disabled = false }) => {
  const { state } = useContext(AppContext)
  const checklistItems = selectChecklistItemsByPhase(state, ChecklistPhase.LoanApplication)
  const visibleChecklistItems = checklistItems.filter(item => (
    !isSolarMonitoringChecklistItem(item) || Boolean(project.monitoringSiteId)
  ))
  const [expandedRows, setExpandedRows] = useState([])
  const hasInitialized = useRef(false)
  const isNotResidential = project.projectType !== 'residential'

  const toggleRow = (id) => {
    setExpandedRows(prev =>
      prev.includes(id)
        ? prev.filter(rowId => rowId !== id)
        : [...prev, id])
  }

  useEffect(() => {
    if (!hasInitialized.current) {
      const allItemIds = visibleChecklistItems.map(item => item.id)

      setExpandedRows(allItemIds)
      hasInitialized.current = true
    }
  }, [visibleChecklistItems])

  return (
    <div
      className={`table-responsive ${disabled ? 'gray-out' : ''}`}
      {...(disabled ? { inert: '' } : {})}
    >
      <table className='table'>
        <tbody>
          {visibleChecklistItems.map((item) => {
            const status = LoanApplicationPhaseShared.getLoanAppChecklistItemStatus(item, project)
            const isSignedContractChecklistItem = item.label === 'Signed Contract'
            const isCustomerPrequalChecklistItem = item.label === 'Customer Prequalification Completed'
            const isReferralSent = item.label === 'Referral Sent'
            const isExpanded = expandedRows.includes(item.id)
            const isDocumentUpload = item.type === ChecklistItemType.DocumentUpload
            const bankerComments = LoanApplicationPhaseShared.getBankerComments(item.label, project)
            const date = status === ChecklistItemStatus.NeedsAction ?
              null : mdyyyy(getChecklistItemDate(item, project))

            return (
              <Fragment key={item.id}>
                {(!isExpanded || !isDocumentUpload) && (
                  isNotResidential && isCustomerPrequalChecklistItem ? <></> :
                    <tr className='align-middle'>
                      <td style={{ width: '30px' }}>
                        <CheckboxIcon
                          isCompleted={status === ChecklistItemStatus.Completed}
                          checklistOwner={item.owner}
                        />
                      </td>
                      <td style={{ maxWidth: '300px' }} className='pointer' onClick={() => toggleRow(item.id)}>
                        {isSignedContractChecklistItem ?
                          <div className='fw-bold text-capitalize'>{getDisplayLabel(item.label)}</div> :
                          <div className='fw-bold mb-1 text-capitalize'>{item.label}</div>
                        }
                        <div className={`text-muted small ${isExpanded ? '' : 'd-block text-truncate'}`}>
                          {item.description}
                          {isReferralSent && project.referralSenderEmail && <div className="text-muted mt-2">
                            Referral sent by <b>{project.referralSenderEmail}</b>
                          </div>}
                        </div>
                        {bankerComments &&
                          <div className={`text-danger small ${isExpanded ? '' : 'd-block text-truncate'}`}>
                            <b>Banker Comments:</b> {bankerComments}
                          </div>}
                      </td>
                      <td className='text-center'>{date}</td>
                      <td className='text-center'>
                        <div className={`badge text-capitalize rounded-pill ${getBadgeClass(status)}`}>{status}</div>
                      </td>
                      <td className='text-capitalize text-center'>{item.owner}</td>
                    </tr>
                )}
                {isExpanded && isDocumentUpload && (
                  <InstallerUploadForm
                    checklistItems={[item]}
                    project={project}
                    onProjectChange={onChange}
                    limitToSlots={[item.label]}
                    bankerComments={bankerComments}
                    handleRowToggle={() => toggleRow(item.id)}
                    isCompleted={status === ChecklistItemStatus.Completed}
                    dateField={date}
                    status={status}
                    checklistOwner={item.owner}
                  />
                )}
              </Fragment>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}